import { render, staticRenderFns } from "./Hierarquias.vue?vue&type=template&id=527cbda3&scoped=true&"
import script from "./Hierarquias.vue?vue&type=script&lang=js&"
export * from "./Hierarquias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cbda3",
  null
  
)

export default component.exports